import { Box, useBreakpointValue } from '@chakra-ui/react';
import { Outlet } from 'react-router-dom';
import { Suspense } from 'react';

import AIAgentv2 from '../ai-agent/v2/AIAgentv2';
// import EddyForSlackPromptBanner from '../learners/overlay/EddyForSlackPromptBanner';
import HubSessionBanner, {
  HUB_SESSION_BANNER_HEIGHT,
} from '../shared/messaging/HubSessionBanner';
import LogoutTimerModal from '../overlay/LogoutTimerModal';
import MainNav from '@/client/components/navigation/MainNav';
import RouteLoading from '../media/RouteLoading';
import SideNav from '@/client/components/navigation/side-navigation/SideNav';
import { useAuthStore } from '@/client/services/state/authStore';
import { useAuthenticatedSession } from '@/client/services/hooks/auth/useAuthenticatedSession';
import { useIsActiveHubSession } from '@/client/services/state/hubSessionStore';

export default function LoggedInLayout() {
  const { authConfig } = useAuthStore();
  const { authtoken, logoutTimer } = useAuthenticatedSession();
  const isHubSession = useIsActiveHubSession();
  const showSideNav = useBreakpointValue({ base: false, lg: true });

  if (authtoken) {
    return (
      <Box position="relative">
        <HubSessionBanner />
        <MainNav />

        {/* MainNav is fixed at 80px; the hub banner shifts it down by its height */}
        <Box paddingTop={isHubSession ? `calc(80px + ${HUB_SESSION_BANNER_HEIGHT})` : '80px'} />

        {showSideNav && <SideNav />}

        <Box paddingLeft={showSideNav ? '80px' : '0px'}>
          <Suspense fallback={<RouteLoading />}>
            <Outlet />
          </Suspense>

          {authConfig?.company?.feature_flags?.enable_knowledgebase_ai_eddy_assistant && (
            <AIAgentv2 />
          )}
        </Box>

        <LogoutTimerModal
          activate={logoutTimer.activate}
          getRemainingTime={logoutTimer.getRemainingTime}
          modalOpen={logoutTimer.modalOpen}
          setModalOpen={logoutTimer.setModalOpen}
        />

        {/* <EddyForSlackPromptBanner /> */}
      </Box>
    );
  }
  return null;
}
